export {RecentSearchesConnected as RecentSearches} from './RecentSearches.connect';
